var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWithLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 70,
    viewBox: "0 0 107 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 16H0.25V5.25H26.75V16ZM26.75 32H0.25V42.75H26.75V32ZM99.25 69.25L79 49C76.8333 50.3333 74.5 51.4167 72 52.25C69.5 52.9167 66.9167 53.25 64.25 53.25C59.25 53.25 54.75 52.0833 50.75 49.75C46.75 47.4167 43.5 44.25 41 40.25C38.6667 36.0833 37.5 31.5833 37.5 26.75C37.5 21.75 38.6667 17.25 41 13.25C43.5 9.25 46.75 6.08333 50.75 3.75C54.75 1.25 59.25 0 64.25 0C69.0833 0 73.5 1.25 77.5 3.75C81.6667 6.08333 84.9167 9.25 87.25 13.25C89.5833 17.25 90.75 21.75 90.75 26.75C90.75 29.4167 90.3333 32 89.5 34.5C88.8333 37 87.8333 39.25 86.5 41.25L106.75 61.75L99.25 69.25ZM80.25 26.75C80.25 23.75 79.5 21.0833 78 18.75C76.5 16.25 74.5 14.3333 72 13C69.6667 11.5 67.0833 10.75 64.25 10.75C61.25 10.75 58.5 11.5 56 13C53.6667 14.3333 51.75 16.25 50.25 18.75C48.9167 21.0833 48.25 23.75 48.25 26.75C48.25 29.5833 48.9167 32.25 50.25 34.75C51.75 37.0833 53.6667 39 56 40.5C58.5 42 61.25 42.75 64.25 42.75C67.0833 42.75 69.6667 42 72 40.5C74.5 39 76.5 37.0833 78 34.75C79.5 32.25 80.25 29.5833 80.25 26.75ZM0.25 69.25H53.5V58.75H0.25V69.25Z",
    fill: "#E2E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWithLine);
export default __webpack_public_path__ + "static/media/search-with-line.bac35dc3c824623b8cf77e035d67f1f6.svg";
export { ForwardRef as ReactComponent };